import { AnyAction } from "redux";
import { cloneDeep } from "lodash";
import { CHANGE_AGENDAMENTO } from "../actions/attendanceRecord";

interface IAttendanceRecord {
  agendamento: any[];
}

const initialState: IAttendanceRecord = {
  agendamento: [],
};

export const changeAgendamentoReducer = (
  state = initialState,
  action: AnyAction
) => {
  switch (action.type) {
    case CHANGE_AGENDAMENTO: {
      return {
        ...cloneDeep(state),
        agendamento: action.agendamento,
      };
    }
    default: {
      return state;
    }
  }
};
